import { Component, Input, SimpleChanges, OnChanges } from '@angular/core'
import { User } from '../../../models/user.model'

@Component({
  selector: 'app-advantage',
  templateUrl: './advantage.component.html',
  styleUrls: ['./advantage.component.scss'],
})
export class AdvantageComponent implements OnChanges {
  @Input() totalDiscount = 0
  @Input() lixDiscountedPrice = 0
  @Input() price = 0
  @Input() priceText: string
  @Input() discountedPriceText: string

  totalSave: number
  lixPrice: number
  vendorPrice: number
  currentUser: User

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['totalDiscount']) {
      this.totalSave = +changes['totalDiscount'].currentValue
    }
    if (changes['lixDiscountedPrice']) {
      this.lixPrice = +changes['lixDiscountedPrice'].currentValue
    }
    if (changes['price']) {
      this.vendorPrice = +changes['price'].currentValue
    }
  }
}
